var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6131 3.67315C13.5894 2.69684 15.1723 2.69684 16.1486 3.67315L17.3271 4.85166C18.3034 5.82797 18.3034 7.41089 17.3271 8.3872L8.66669 17.0476C8.55035 17.164 8.40219 17.2432 8.24086 17.2755L3.82145 18.1594C3.23834 18.276 2.72424 17.7619 2.84086 17.1788L3.72475 12.7594C3.75701 12.5981 3.83631 12.4499 3.95264 12.3336L12.6131 3.67315ZM14.9701 4.85166L16.1486 6.03017C16.474 6.35561 16.474 6.88325 16.1486 7.20868L14.9701 8.3872L12.6131 6.03018L13.7916 4.85166C14.117 4.52623 14.6447 4.52623 14.9701 4.85166ZM11.4346 7.20869L5.30957 13.3337L4.72031 16.28L7.66659 15.6907L13.7916 9.56571L11.4346 7.20869Z",
    fill: "#6F767E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.0afa07af6aab86cd3d8b87379feb0292.svg";
export { ForwardRef as ReactComponent };